import { Haptics } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";
import { errorLog } from "./logger";

export const vibrateDevice = async () => {
  // Haptics requires the browser to support window.navigator.vibrate
  if (Capacitor.getPlatform() === "web" && (!window.navigator || !window.navigator.vibrate)) {
    return;
  }

  try {
    await Haptics.vibrate({ duration: 150 });
  } catch (e: any) {
    // In case there are any other browsers that don't support vibration, so we can update the guard later
    errorLog(e);
  }
};
